import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../entities/Constants';
import { IColorUserAdminV1, IColorUserV1, IxellAPIService } from '../../tools/api.service';
import { ErrorService } from '../../tools/error.service';
import { HeaderService } from '../../tools/header.service';
import { Utils } from '../../tools/utils';

@Component({
    selector: 'app-adminlacour-color-user',
    templateUrl: './adminlacour-color-user.component.html',
    styleUrls: ['./adminlacour-color-user.component.scss']
})
export class AdminlacourColorUserComponent implements OnInit {
    displayedColumnsS0: string[] = ["idcolorUser", "companySocialReason", "address", "name", "country", "unisiteCode", "dateMailSent", "edit"];
    displayedColumnsS1: string[] = ["idcolorUser", "companySocialReason", "address", "name", "country", "unisiteCode", "dateMailSent", "edit", "admin"];
    displayedColumnsS2: string[] = ["idcolorUser", "companySocialReason", "address", "name", "country", "unisiteCode", "mailSended", "dateMailSent", "edit"];// @caroline -- à supprimer une fois les contrôles de code Unisite terminés

    displayedColumns: string[];


    // js pour les tab
    actualstatus: number = null;
    actualtab = '';
    actualpane = '';

    // Sub
    allColorUserSub: any;
    currentColorUserSub: any;
    similarColorUserSub: any;
    updateStatusSub: any;
    updateUnisiteCodeSub: any;
    historyColorUserSub: any;

    // Objets et tableaux
    currentColorUser: IColorUserAdminV1;
    allColorUser: IColorUserAdminV1[] = [];
    colorUserStatus: IColorUserAdminV1[] = [];
    colorUserSource: any;
    similarColorUser: IColorUserV1[] = [];
    logInfo: any[] = [];

    showEditModal: boolean = false;
    haveUnisiteCode: boolean = false;

    infosUserForm = new FormGroup({
        unisiteCode: new FormControl(''),
        haveUnisiteCode: new FormControl(1)
    });

    private paginator: MatPaginator;

    constructor(private api: IxellAPIService, private errorService: ErrorService, private formBuilder: FormBuilder, private headerService: HeaderService, private _snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        Utils.deleteStorageData();
        this.getData(0);
        this.actualstatus = 0;
        this.actualtab = "nav-stat0-tab";
        this.actualpane = "nav-stat0";

        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);

        this.headerService.changeTitle("IxellWebLab");

        this.infosUserForm.controls['unisiteCode'].setValidators([Validators.required]);
        this.infosUserForm.controls['unisiteCode'].markAsTouched();
        
        this.haveUnisiteCode = true;
        this.infosUserForm.controls['unisiteCode'].updateValueAndValidity();

    }


    setDataSourceAttributes() {
        if (this.colorUserSource != null) {
            this.colorUserSource.paginator = this.paginator;
        }
    }

    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        this.paginator = mp;
        this.paginator._intl.itemsPerPageLabel = "Eléments par page";
        this.paginator._intl.firstPageLabel = "première page";
        this.paginator._intl.lastPageLabel = "dernière page";
        this.setDataSourceAttributes();
    }

    closeModal(name: string) {
        let Modal = document.getElementById(name);
        Modal.style.display = "none";
    }

    openModal(name: string) {
        let Modal = document.getElementById(name);
        Modal.style.display = "block";
    }

    getData(status: number) {
        this.colorUserStatus = [];
        this.colorUserSource = null;
        this.allColorUser = [];
        this.allColorUserSub = this.api.getColorUsersbyStatusAdmin(status).subscribe(data => {
            if (data != null) {
                data.forEach(item => {
                    this.colorUserStatus.push(item);
                });
                switch (status) {
                    case 0:
                        this.colorUserStatus.sort((a, b) => { return Constants.compare(a.idcolorUser, b.idcolorUser, true); })
                        this.colorUserSource = new MatTableDataSource(this.colorUserStatus);
                        this.displayedColumns = this.displayedColumnsS0;
                        break;
                    case 1:
                        this.colorUserSource = new MatTableDataSource(this.colorUserStatus);
                        this.displayedColumns = this.displayedColumnsS1;
                        break;
                    case 2:// @caroline -- à supprimer une fois les contrôles de code Unisite terminés
                        this.colorUserSource = new MatTableDataSource(this.colorUserStatus);
                        this.displayedColumns = this.displayedColumnsS2;
                        break;
                }
            }
            if (this.allColorUserSub != null) this.allColorUserSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getData", new Date().toString());
            if (this.allColorUserSub != null) this.allColorUserSub.unsubscribe();
        });
    }

    // Rechercher
    applyFilter(filterValue: string) {
        this.colorUserSource.filter = filterValue.trim().toLowerCase();
    }


    refreshTab() {
        this.paginator.pageIndex = 0;
        let tab = this.actualtab;
        switch (tab) {
            case "nav-stat0-tab":
                this.getData(0);
                break;
            case "nav-stat1-tab":
                this.getData(1);
                break;
            case "nav-stat2-tab":// @caroline -- à supprimer une fois les contrôles de code Unisite terminés
                this.getData(2);
                break;
        }
    }

    toggleTab(status: number, pane: string, tab: string) {
        this.paginator.pageIndex = 0;
        this.getData(status);
        document.getElementById(this.actualtab).classList.remove("active");
        document.getElementById(tab).classList.add("active");
        this.actualpane = pane;
        this.actualtab = tab;
        this.actualstatus = status;
    }

    displayInfoUser(user: IColorUserAdminV1) {
        let status;
        this.similarColorUser = []; /*console.log("0", this.similarColorUser);*/
        this.currentColorUserSub = this.api.getColorUserbyID(user.idcolorUser).subscribe(data => {
            status = data.statusAdmin;
            if (status == this.actualstatus) {
                this.similarColorUserSub = this.api.getSimilarColorUserAdmin(user).subscribe(data2 => {
                    this.similarColorUser.push(...data2.filter(i => i.postalCode == user.postalCode && i.socialReason == user.socialReason));
                    this.similarColorUser.push(...data2.filter(i => i.postalCode == user.postalCode && !this.similarColorUser.includes(i)));
                    this.similarColorUser.push(...data2.filter(i => !this.similarColorUser.includes(i)));
                    this.showEditModal = true;
                    this.currentColorUser = user;
                    this.openModal("editModal");
                    this.infosUserForm.controls["unisiteCode"].setValue(this.currentColorUser.unisiteCode);
                    //if (this.currentColorUser.unisiteCode != null) {
                    //    this.infosUserForm.controls["haveUnisiteCode"].setValue(1);
                    //    this.haveUnisiteCode = true;
                    //}
                    //else {
                    //    this.infosUserForm.controls["haveUnisiteCode"].setValue(0);
                    //    this.haveUnisiteCode = false;
                    //}
                    if (this.similarColorUserSub != null) this.similarColorUserSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "similarColorUserSub", new Date().toString());
                    if (this.similarColorUserSub != null) this.similarColorUserSub.unsubscribe();
                });
            }
            else {
                this.openSnackBar("Le client a déjà été traité", "OK");
                this.getData(this.actualstatus);
            }


            if (this.currentColorUserSub != null) this.currentColorUserSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateColorUserStatusByAdmin", new Date().toString());
            if (this.currentColorUserSub != null) this.currentColorUserSub.unsubscribe();
        });

    }

    //userHaveUnisiteCode(bool: boolean) {
    //    if (bool) {
    //        this.infosUserForm.controls['unisiteCode'].setValidators([Validators.required]);
    //        this.infosUserForm.controls['unisiteCode'].markAsTouched();
    //    }
    //    else {
    //        this.infosUserForm.controls['unisiteCode'].setValidators([]);
    //    }

    //    this.haveUnisiteCode = bool;
    //    this.infosUserForm.controls['unisiteCode'].updateValueAndValidity();
    //}

    updateUnisiteCodeAndStatus() {
        var unisiteCode = null;
        if (this.haveUnisiteCode) unisiteCode = this.infosUserForm.controls["unisiteCode"].value;
        if (this.actualstatus == 0) {
            if (!this.haveUnisiteCode || (this.haveUnisiteCode && !Utils.IsNullOrWhiteSpace(unisiteCode))) {
                this.updateUnisiteCodeSub = this.api.updateColorUserUnisiteCodeAndStatusByAdmin(this.currentColorUser.idcolorUser, unisiteCode).subscribe(data => {
                    if (data) {
                        this.toggleTab(1, 'nav-stat1', 'nav-stat1-tab');
                    }
                    this.closeModal("editModal");
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateColorUserStatusByAdmin", new Date().toString());
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                });
            }
        }

        else if (this.actualstatus == 1) {
            if ((!this.haveUnisiteCode && unisiteCode != this.currentColorUser.unisiteCode)
                || (this.haveUnisiteCode && !Utils.IsNullOrWhiteSpace(unisiteCode) && unisiteCode != this.currentColorUser.unisiteCode)) {
                this.updateUnisiteCodeSub = this.api.updateColorUserUnisiteCodeAndStatusByAdmin(this.currentColorUser.idcolorUser, unisiteCode).subscribe(data => {
                    if (data) {
                        this.getData(1);
                    }
                    this.closeModal("editModal");
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateColorUserStatusByAdmin", new Date().toString());
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                });
            }
            else if ((!this.haveUnisiteCode && unisiteCode == this.currentColorUser.unisiteCode)
                || (this.haveUnisiteCode && unisiteCode == this.currentColorUser.unisiteCode && !Utils.IsNullOrWhiteSpace(unisiteCode))) {
                this.closeModal("editModal");
            }
        }
        else if (this.actualstatus == 2) {  // @caroline -- à supprimer une fois les contrôles de code Unisite terminés
            if (!this.haveUnisiteCode || (this.haveUnisiteCode && !Utils.IsNullOrWhiteSpace(unisiteCode))) {
                this.updateUnisiteCodeSub = this.api.updateColorUserUnisiteCodeAndStatusByAdmin(this.currentColorUser.idcolorUser, unisiteCode).subscribe(data => {
                    if (data) {
                        this.toggleTab(2, 'nav-stat2', 'nav-stat2-tab');
                    }
                    this.closeModal("editModal");
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateColorUserStatusByAdmin", new Date().toString());
                    if (this.updateStatusSub != null) this.updateStatusSub.unsubscribe();
                });
            }
        }
    }


    displayHistory(user: IColorUserAdminV1) {
        this.logInfo = [];
        this.historyColorUserSub = this.api.getColorUserAdminHistoById(user.idcolorUser).subscribe(data => {
            if (data) {
                data.forEach(item => {
                    var index = item.infosComp.indexOf("unisiteCode:") + 12;
                    var unisiteCode = item.infosComp.substring(index);
                    item.infosComp = unisiteCode;
                    var date = new Date(Date.UTC(item.logDate.getFullYear(), item.logDate.getMonth(), item.logDate.getDate(), item.logDate.getHours(), item.logDate.getMinutes(), item.logDate.getSeconds()));
                    item.logDate = date;
                    this.logInfo.push(item);
                });
            }
            if (this.historyColorUserSub != null) this.historyColorUserSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getColorUserAdminHistobyId", new Date().toString());
            if (this.historyColorUserSub != null) this.historyColorUserSub.unsubscribe();
        });
        this.openModal('histoModal');
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }

    calculateClasses() {
        let temp = {
            'contentWithTable': this.similarColorUser.length > 0,
            'contentWithoutTable': this.similarColorUser.length == 0
        }
        return temp;
    }

    sortScale(sort: Sort, status: string) {
        var data = this.colorUserStatus;
        Constants.sortScale(sort, status, data);
        this.colorUserStatus = data.slice();
        this.colorUserSource = new MatTableDataSource(this.colorUserStatus);
    }

}
